import { eventHasRun } from '../../utils/eventTracker';

export const DDC_SLIDESHOW_CLICK = 'ddc.slideshow.click';

function click({ currentTarget: element, timeStamp }) {
	let eventObject;
	const $element = $(element);

	if (
		!eventHasRun(DDC_SLIDESHOW_CLICK, {
			timeStamp
		})
	) {
		eventObject = {
			eventType: DDC_SLIDESHOW_CLICK,
			eventData: {
				element,
				name: $element.data('slide-label'),
				position: $element.data('slide-position'),
				type: $element.data('slide-type')
			}
		};
	}

	return eventObject;
}

export default click;
